module.exports = __webpack_public_path__ + "img/partner-list-8.2f88298d.png";